var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useField, useFormikContext } from 'formik';
import React from 'react';
import { DurationPicker } from '../../Components/DurationPicker/DurationPicker';
import { FormikTextField } from '../../Components/FormikFields/FormikTextField';
import { numberGreaterThanZeroInputFilter } from '../../Shared/InputFilters';
import styles from './MedicationListDefaultOverride.module.css';
import { MedicationListDefaultOverrideSection } from './MedicationListDefaultOverrideSection';
export var MedicationListDefaultOverride = function () {
    var form = useFormikContext();
    var _a = __read(useField('defaultDuration'), 3), field = _a[0], meta = _a[1], helpers = _a[2];
    var defaultDurationError = meta.touched ? meta.error : '';
    return (React.createElement("div", { className: styles.container },
        React.createElement(MedicationListDefaultOverrideSection, { field: 'defaultPackAmountOverridden', title: 'Change default number of packs' },
            React.createElement("div", { className: styles.packAmount },
                React.createElement(FormikTextField, { label: 'No. of packs', filterFunction: numberGreaterThanZeroInputFilter, required: true, name: 'defaultPackAmount', testId: 'pack-amount-default', onChange: function () {
                        form.setFieldError('defaultPackAmount', '');
                    } }))),
        React.createElement(MedicationListDefaultOverrideSection, { field: 'defaultDurationOverridden', title: 'Change default course duration' },
            React.createElement(DurationPicker, { timeLength: form.values.defaultDuration, testId: 'duration-picker', required: true, onUpdateTimeLength: function (value) {
                    form.setFieldValue('defaultDuration', value);
                    form.setFieldError('defaultDuration', '');
                    form.setFieldTouched('defaultDuration', true, false);
                }, error: defaultDurationError })),
        React.createElement(MedicationListDefaultOverrideSection, { field: 'defaultDosageInstructionsOverridden', title: 'Change default dosage instructions' },
            React.createElement(FormikTextField, { label: 'Dosage instructions', required: true, name: 'defaultDosageInstructions', testId: 'dosage-instructions-default', maxLength: 250, onChange: function () {
                    form.setFieldError('defaultDosageInstructions', '');
                } }))));
};
